import Fluxxor from 'fluxxor';
export const constants = {
  SET_LANGUAGECODE: 'TRANSLATIONS:SET_LANGUAGECODE',
};

export const TranslationStore = Fluxxor.createStore({
  initialize() {
    this.languageCode = 'en';
    this.languageCodes = [
      {
        code: 'en',
        name: 'English',
      },
      {
        code: 'es',
        name: 'Español',
      },
      {
        code: 'nl',
        name: 'Nederlands',
      },
      {
        code: 'de',
        name: 'Deutsch',
      },
      {
        code: 'fr',
        name: 'Français',
      },
      {
        code: 'it',
        name: 'Italiano',
      },
    ].sort((a, b) => {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    });
    this.bindActions(
      constants.SET_LANGUAGECODE, this.setLanguageCode,
    );
  },
  setLanguageCode(languageCode) {
    if (this.languageCode !== languageCode || window.langCode !== languageCode) {
      this.languageCode = languageCode;
      window.langCode = languageCode;
    }
    this.emit('change');
  },
  getLanguageCode() {
    return this.languageCode;
  },

  getLanguageCodes() {
    return this.languageCodes;
  },
  getLangNameForCode(languageCode) {
    const lang = this.languageCodes.find(language => language.code === languageCode);
    return !!lang ? lang.name : '';
  }
});
